import React from "react";
import axios from "../../../../api/axios";
import Swal from "sweetalert2";

const Approve = ({ id, targetCars, children }) => {
  const storedToken = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");
  const token = "Bearer " + storedToken.replace(/"/g, "");

  const headers = {
    Authorization: token,
    "Content-Type": "application/json",
  };

  const sendApproval = () => {
    const body = {
      adminId: userId,
      reportId: id,
      approved: true,
      amount: 0, // default
      targetCars: targetCars || "",
    };

    axios
      .post("/api/reports/approve", body, { headers })
      .then(() => {
        Swal.fire({
          icon: "success",
          text: "Raportimi është aprovuar me sukses!",
          showConfirmButton: true,
          confirmButtonColor: "#18817d",
          confirmButtonText: "Mbyll",
          timer: 2500,
        });

        setTimeout(() => {
          window.location.href = "/admin/report";
        }, 2500);
      })
      .catch((error) => {
        let errorMessage = "Diçka shkoi keq! Ju lutemi provoni përsëri.";

        // if backend sends validation errors, show them instead of generic message
        if (error.response?.data?.errors) {
          errorMessage = error.response.data.errors.join(", ");
        } else if (typeof error.response?.data === "string") {
          errorMessage = error.response.data;
        }

        Swal.fire({
          icon: "error",
          text: errorMessage,
          timer: 2500,
          showConfirmButton: true,
          confirmButtonColor: "#18817d",
          confirmButtonText: "Mbyll",
        });
      });
  };

  return children(sendApproval);
};

export default Approve;
